// extracted by mini-css-extract-plugin
export default {"body":"empty_record_body__JeDC1","empty_record":"empty_record_empty_record__a7uSn"};